import { TickSpaceIndex } from "../../../model/canister/KLine";

export const parseResolutionToTickSpaceIndex = (resolution: string) => {
  switch (resolution) {
    case '1':
      return TickSpaceIndex.OneMinute;
    case '5':
      return TickSpaceIndex.FiveMinutes;
    case '15':
      return TickSpaceIndex.FifteenMinutes;
    case '30':
      return TickSpaceIndex.ThirtyMinutes;
    case '60':
      return TickSpaceIndex.OneHour;
    case '240':
      return TickSpaceIndex.FourHours;
    case 'D':
      return TickSpaceIndex.OneDay;
    case 'W':
      return TickSpaceIndex.Week;
    case 'M':
      return TickSpaceIndex.Month;
    default:
      return TickSpaceIndex.FifteenMinutes;
  }
};